// src/pages/help/LeagueHelp.js
import React from "react";
import { Link } from "react-router-dom";

const LeagueHelp = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="mb-6">
        <Link to="/help" className="text-deep-red hover:text-bright-red">
          &larr; Back to Help Center
        </Link>
      </div>
      <h1 className="text-3xl font-bold text-dark-grey mb-6">League Help</h1>
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">League Management</h2>
          <p className="text-medium-grey">
            This page provides helpful information about managing your fantasy MMA leagues, including 
            creating leagues, inviting players, and league settings.
          </p>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Commissioner Duties</h2>
          <p className="text-medium-grey mb-4">
            As a league commissioner, you are responsible for:
          </p>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li>Setting up the league and configuring rules</li>
            <li>Inviting and approving new members</li>
            <li>Managing league disputes</li>
            <li>Ensuring fair play among all participants</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">League Settings</h2>
          <p className="text-medium-grey mb-4">
            League settings you can customize include:
          </p>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li><span className="font-medium">League Name and Description:</span> Personalize your league</li>
            <li><span className="font-medium">Public/Private:</span> Control who can join your league</li>
            <li><span className="font-medium">Member Limit:</span> Set the maximum number of participants</li>
            <li><span className="font-medium">Scoring Rules:</span> Customize how points are awarded (if available)</li>
            <li><span className="font-medium">Season Length:</span> Determine how long your league competition runs</li>
          </ul>
        </section>
        
        <section>
          <h2 className="text-2xl font-semibold text-dark-grey mb-4">Member Management</h2>
          <p className="text-medium-grey">
            As a commissioner, you can:
          </p>
          <ul className="list-disc pl-5 text-medium-grey space-y-2">
            <li>Invite new members via email or username</li>
            <li>Remove inactive or inappropriate members</li>
            <li>Promote other members to commissioner status</li>
            <li>Send league-wide announcements and messages</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default LeagueHelp;
